import React, { memo } from 'react';

import { EventInfo } from '@/api/events/types/types';
import { PlayerPositionsFilters } from '@/feature/lobby/components/PlayerPositionFilters';
import { PlayerProjectionsFilters } from '@/feature/lobby/components/PlayerProjectionsFilters';
import { FilterType, Filters } from '@/feature/lobby/utils/filters';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { League } from '@/types/api.generated';
import { hasPositionFilters } from '@/utils/league';

/**
 * A component that renders either position or projection filters for players
 * based on the provided filter type and league.
 *
 * @param leagueId league name from where to get the filters
 * @param filterType Position or Projection
 * @param events list of events
 */

export const PLAYER_FILTERS_HEIGHT = 68;
export const PlayersFilters = memo(
    ({ leagueId, filterType, events }: { leagueId: League; filterType?: FilterType; events: EventInfo[] }) => {
        if (!filterType) {
            return null;
        }
        const hideFilter = filterType === Filters.Position && !hasPositionFilters(leagueId);

        return (
            <MaxWidthWrapper flex={1} minHeight={hideFilter ? 16 : PLAYER_FILTERS_HEIGHT}>
                {filterType === Filters.Projection ? (
                    <PlayerProjectionsFilters key={`filters_${leagueId}`} events={events} />
                ) : (
                    <PlayerPositionsFilters key={`filters_${leagueId}`} league={leagueId} />
                )}
            </MaxWidthWrapper>
        );
    }
);
